import { CSSProperties } from "react";

export const styles: { [key: string]: CSSProperties } = {
  container: {
    width: "90%",
    margin: "0 auto",
    marginTop: "50px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 3
  },
  title: {
    fontSize: 25,
  },
  table: {
    marginTop: 5,
    marginBottom: "100px",
  },
  tableHead: {
    backgroundColor: "#ddd",
  },
  noData: {
    textAlign: "center",
  },
  paper: {
    display: "block",
    padding: 2,
  },
  link: {
    display: "block",
    padding: 1,
    cursor: "pointer",
    textDecoration: "none",
    color: "#000",
  },
  button: {
    marginTop: 2,
  },
};
